import React, { useEffect } from "react";
import { privacySeo, setPageSeo } from "../seo";
import cardsWhiteLogoUrl from "../assets/Logo - Cards - white.svg";

const privacyText = `PRIVACY POLICY OFC CARDS

Ultimo aggiornamento: 30 aprile 2026

INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI
ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 (“GDPR”)

1. CHE COSA RIGUARDA QUESTA INFORMATIVA?

La presente informativa descrive come OFC S.R.L. tratta i dati personali nell’ambito del servizio “OFC Cards”, accessibile tramite il dominio cards.ofc.link e relativi sottodomini, pagine, card digitali, landing pubbliche, moduli, link, QR code, NFC o altri strumenti digitali collegati.

OFC Cards consente di creare, pubblicare, gestire e condividere card digitali, profili pubblici, landing page, pagine contatto, pagine promozionali o altri contenuti online.

La presente informativa riguarda:

- gli utenti che creano o gestiscono una card;
- gli utenti che visitano una card o una landing pubblica;
- gli utenti che compilano eventuali form;
- i clienti, referenti o soggetti che interagiscono con OFC Cards.

2. TITOLARE DEL TRATTAMENTO

Il Titolare del trattamento è:

OFC S.R.L.
Viale San Nilo 39C, 00046 Grottaferrata (RM) – Italia
P.IVA: 16390181002
PEC: ofc@pecformail.it
Telefono: 0694502976
Email: privacy@onoranzefunebricloud.com

Per richieste relative alla privacy è possibile scrivere a:
privacy@onoranzefunebricloud.com

3. QUALI DATI PERSONALI TRATTIAMO?

OFC S.R.L. tratta dati diversi a seconda dell’utilizzo del servizio.

3.1 Dati inseriti nelle card digitali

Le card possono contenere dati e contenuti inseriti volontariamente dall’utente o dal Cliente, quali, a titolo esemplificativo:

- nome e cognome;
- nome dell’azienda, attività o brand;
- ruolo professionale;
- fotografia, avatar, logo o immagine profilo;
- numero di telefono;
- indirizzo email;
- indirizzo o sede aziendale;
- link a siti web;
- link a profili social;
- link a WhatsApp, Telegram o altri canali di contatto;
- descrizioni personali, professionali o aziendali;
- immagini, file, presentazioni o altri contenuti caricati;
- URL, QR code, slug o link personalizzati.

Chi inserisce tali dati è responsabile della loro correttezza, liceità e aggiornamento.

3.2 Dati per registrazione, accesso e gestione tramite email e OTP

Per creare, attivare o gestire una card, OFC Cards può richiedere un indirizzo email.

Il servizio non prevede necessariamente un login tradizionale con password. L’accesso alla gestione della card può avvenire tramite codice OTP, link temporaneo o altro meccanismo di verifica inviato all’indirizzo email indicato.

In questi casi possiamo trattare:

- indirizzo email;
- codice OTP o identificativo tecnico della verifica;
- data e ora della richiesta;
- data e ora della verifica;
- esito della verifica;
- eventuali tentativi non riusciti;
- log tecnici necessari alla sicurezza;
- dati relativi alla card associata all’indirizzo email.

Questi dati sono utilizzati per verificare l’accesso, consentire la creazione e gestione della card e prevenire abusi.

3.3 Dati raccolti tramite form

La semplice visita di una card pubblica non comporta la compilazione di form né la raccolta diretta di dati identificativi del visitatore.

Eventuali dati personali possono essere raccolti solo quando l’utente li fornisce volontariamente tramite form presenti su landing pubbliche, pagine informative, pagine di richiesta contatto, richiesta demo, richiesta informazioni, richiesta coupon o altre aree specifiche.

In questi casi possiamo trattare, a titolo esemplificativo:

- nome e cognome;
- email;
- numero di telefono;
- azienda o organizzazione;
- ruolo professionale;
- messaggio o richiesta inviata;
- eventuali preferenze espresse;
- dati necessari a gestire la richiesta.

3.4 Dati dei visitatori di card e landing pubbliche

La semplice navigazione su card e landing pubbliche non comporta, da parte di OFC S.R.L., la raccolta diretta di dati identificativi dell’utente, salvo quanto strettamente necessario al funzionamento tecnico del servizio.

OFC Cards può utilizzare strumenti analytics anonimizzati o aggregati, come OpenPanel o strumenti analoghi, per misurare l’utilizzo generale del servizio senza identificare direttamente il singolo visitatore pubblico.

Le informazioni statistiche possono includere, in forma anonima o aggregata:

- numero di visite;
- pagine visualizzate;
- provenienza approssimativa del traffico;
- dispositivo o browser in forma generale;
- eventi aggregati;
- performance generali del servizio.

Tali dati non sono utilizzati per profilazione pubblicitaria, remarketing o pubblicità comportamentale.

3.5 Dati di utilizzo dell'area gestione autenticata

Quando l'utente accede all'area di gestione tramite email, OTP o link temporaneo, possiamo associare al profilo verificato e alla card o azienda collegata alcuni eventi tecnici e di utilizzo del prodotto.

Questi eventi possono riguardare, ad esempio:

- accesso all'area gestione;
- creazione, modifica o aggiornamento della card;
- utilizzo di funzioni come QR code, firma email, Avatar AI, ricerca P.IVA o acquisto crediti;
- piano attivo, stato della card e funzioni abilitate;
- esiti tecnici o errori necessari a sicurezza, assistenza e miglioramento del servizio.

Non tracciamo tramite analytics codici OTP, contenuto dei messaggi, numeri di telefono, P.IVA, PEC, indirizzi completi o dati di pagamento completi.

3.6 Dati tecnici e di sicurezza

Per garantire il corretto funzionamento, la sicurezza e la protezione del servizio, possiamo trattare dati tecnici quali:

- log applicativi;
- eventi di sicurezza;
- tentativi di accesso;
- errori tecnici;
- dati relativi a malfunzionamenti;
- informazioni necessarie a prevenire spam, abusi, accessi non autorizzati o attività fraudolente.

4. COME RACCOGLIAMO I DATI?

I dati possono essere raccolti:

- quando l’utente crea o gestisce una card;
- quando l’utente inserisce la propria email per ricevere un codice OTP o link temporaneo;
- quando l’utente compila un form;
- quando l’utente contatta OFC tramite email, telefono, WhatsApp o altri canali;
- tramite strumenti tecnici necessari al funzionamento e alla sicurezza del servizio;
- tramite analytics anonimizzati o aggregati per visitatori pubblici;
- tramite analytics tecnici associati al profilo verificato per l'area gestione autenticata.

Non utilizziamo processi decisionali esclusivamente automatizzati che producano effetti giuridici sull’utente o incidano significativamente sulla sua persona.

5. PER QUALI FINALITÀ TRATTIAMO I DATI E SU QUALE BASE GIURIDICA?

5.1 Creazione, pubblicazione e gestione delle card

Trattiamo i dati per consentire la creazione, modifica, pubblicazione, visualizzazione e condivisione delle card digitali.

Base giuridica:
- esecuzione di un contratto o di misure precontrattuali;
- legittimo interesse al corretto funzionamento del servizio.

5.2 Accesso tramite email e OTP

Trattiamo l’indirizzo email e i dati tecnici collegati per inviare codici OTP o link temporanei, verificare l’accesso e consentire la gestione della card.

Base giuridica:
- esecuzione di un contratto o di misure precontrattuali;
- legittimo interesse alla sicurezza del servizio e alla prevenzione di abusi.

5.3 Gestione di form e richieste

Trattiamo i dati inviati volontariamente tramite form, email, telefono, WhatsApp o altri canali per rispondere alle richieste dell’utente, fornire informazioni, gestire richieste demo, attivazioni, coupon o assistenza.

Base giuridica:
- esecuzione di misure precontrattuali richieste dall’interessato;
- esecuzione del contratto, ove applicabile;
- legittimo interesse a rispondere alle richieste ricevute.

5.4 Funzionamento tecnico, sicurezza e prevenzione abusi

Trattiamo dati tecnici e log per garantire sicurezza, continuità del servizio, prevenzione di accessi non autorizzati, spam, frodi, usi anomali o malfunzionamenti.

Base giuridica:
- legittimo interesse del Titolare;
- obblighi di legge, ove applicabili.

5.5 Analytics e statistiche di utilizzo

Utilizziamo strumenti analytics anonimizzati o aggregati per misurare visualizzazioni, performance e utilizzo generale di card e landing pubbliche. Nell'area gestione autenticata possiamo inoltre trattare eventi tecnici associati al profilo verificato e alla card o azienda collegata per misurare l'uso delle funzionalità, fornire assistenza, migliorare il prodotto e prevenire abusi.

Base giuridica:
- legittimo interesse al miglioramento del servizio, quando i dati sono anonimizzati o aggregati.
- esecuzione del contratto e legittimo interesse al corretto funzionamento, alla sicurezza, all'assistenza e al miglioramento del servizio per gli utenti autenticati.

5.6 Adempimenti amministrativi, contabili e fiscali

Qualora il rapporto con il Cliente comporti obblighi amministrativi, contrattuali o fiscali, trattiamo i dati necessari a tali adempimenti.

Base giuridica:
- esecuzione del contratto;
- obblighi di legge.

5.7 Comunicazioni promozionali

I dati raccolti tramite card, landing, form o OTP non saranno utilizzati per finalità promozionali senza consenso specifico e separato dell’utente, salvo i casi consentiti dalla normativa applicabile.

Base giuridica:
- consenso dell’interessato;
- legittimo interesse, solo nei limiti consentiti dalla normativa applicabile.

6. COOKIE E STRUMENTI DI TRACCIAMENTO

OFC Cards utilizza solo cookie tecnici o strumenti equivalenti necessari al corretto funzionamento del servizio, alla sicurezza, alla gestione delle sessioni tecniche e all’erogazione delle funzionalità richieste.

Non utilizziamo cookie di profilazione, cookie di marketing, pixel pubblicitari, remarketing o strumenti analoghi sulle card e landing pubbliche, salvo diversa informativa e, ove necessario, consenso dell’utente.

Gli eventuali analytics utilizzati sulle card e landing pubbliche sono configurati, per quanto possibile, in forma anonimizzata, aggregata o cookieless, e non sono finalizzati all’identificazione del singolo visitatore pubblico. Nell'area gestione autenticata, alcuni eventi tecnici possono essere collegati al profilo verificato e alla card o azienda associata.

7. PER QUANTO TEMPO CONSERVIAMO I DATI?

I dati personali sono conservati per il tempo necessario al raggiungimento delle finalità per cui sono stati raccolti.

In particolare:

- dati pubblicati nelle card: per la durata di pubblicazione della card o fino alla richiesta di modifica, disattivazione o cancellazione;
- dati email e OTP: per il tempo necessario alla verifica, alla gestione dell’accesso e alla prevenzione di abusi;
- dati raccolti tramite form: per il tempo necessario a gestire la richiesta e, se necessario, per eventuali esigenze amministrative, contrattuali o difensive;
- dati tecnici e di sicurezza: per il tempo proporzionato alle esigenze di sicurezza e prevenzione abusi;
- dati amministrativi, contrattuali e fiscali: per il periodo previsto dalla normativa applicabile, generalmente 10 anni;
- dati marketing, ove raccolti con consenso: fino alla revoca del consenso o per il diverso periodo indicato al momento della raccolta;
- statistiche anonime o aggregate: possono essere conservate anche per periodi più lunghi, in quanto non riferibili direttamente a una persona identificata o identificabile.

8. A CHI POSSONO ESSERE COMUNICATI I DATI?

I dati personali possono essere trattati da:

- personale e collaboratori autorizzati da OFC;
- fornitori tecnici necessari al funzionamento del servizio;
- fornitori di hosting, infrastruttura cloud, sicurezza e manutenzione;
- fornitori di servizi email transazionali, anche per l’invio di OTP o comunicazioni tecniche;
- strumenti di analytics anonimizzati o aggregati, come OpenPanel o strumenti analoghi, e strumenti analytics tecnici per l'area gestione autenticata;
- consulenti fiscali, legali, amministrativi o tecnici;
- autorità pubbliche, giudiziarie o amministrative, ove richiesto dalla legge.

I soggetti che trattano dati per conto di OFC sono, ove necessario, nominati responsabili del trattamento ai sensi dell’art. 28 GDPR.

OFC non comunica dati personali a terzi per finalità promozionali senza consenso specifico dell’utente, salvo i casi consentiti dalla normativa applicabile.

9. TRASFERIMENTO DEI DATI FUORI DALLO SPAZIO ECONOMICO EUROPEO

OFC privilegia, ove possibile, fornitori situati nello Spazio Economico Europeo o che offrano garanzie adeguate ai sensi del GDPR.

Qualora alcuni fornitori trattino dati personali al di fuori dello Spazio Economico Europeo, il trasferimento avverrà nel rispetto della normativa applicabile, ad esempio sulla base di decisioni di adeguatezza, clausole contrattuali standard o altre garanzie previste dal GDPR.

10. SICUREZZA DEI DATI

OFC adotta misure tecniche e organizzative adeguate a proteggere i dati personali da accessi non autorizzati, perdita, distruzione, alterazione o uso improprio.

Le misure possono includere, a titolo esemplificativo:

- protezione degli accessi;
- verifica tramite email e OTP;
- controlli tecnici e log di sicurezza;
- backup e misure di continuità;
- limitazione degli accessi ai soli soggetti autorizzati;
- monitoraggio di abusi, anomalie o utilizzi fraudolenti.

11. DIRITTI DELL’INTERESSATO

L’interessato può esercitare, nei limiti previsti dalla normativa applicabile, i seguenti diritti:

- accesso ai dati personali;
- rettifica dei dati inesatti;
- cancellazione dei dati;
- limitazione del trattamento;
- opposizione al trattamento;
- portabilità dei dati, ove applicabile;
- revoca del consenso, ove il trattamento sia basato sul consenso.

Per esercitare i diritti o richiedere informazioni sul trattamento dei dati personali è possibile scrivere a:

privacy@onoranzefunebricloud.com

L’interessato ha inoltre il diritto di presentare reclamo al Garante per la Protezione dei Dati Personali, qualora ritenga che il trattamento violi la normativa applicabile.

12. RIMOZIONE O MODIFICA DEI CONTENUTI PUBBLICATI

Chi desidera richiedere la modifica, rimozione o segnalazione di contenuti presenti in una card o landing può contattare OFC all’indirizzo:

privacy@onoranzefunebricloud.com

La richiesta dovrebbe indicare:

- URL della card o landing;
- contenuto oggetto della richiesta;
- motivo della richiesta;
- dati di contatto del richiedente;
- eventuale documentazione utile.

OFC potrà richiedere ulteriori informazioni per verificare la legittimazione del richiedente e valutare la richiesta.

13. MODIFICHE ALLA PRESENTE INFORMATIVA

OFC può aggiornare la presente Privacy Policy in qualsiasi momento, anche in ragione di modifiche normative, tecniche, organizzative o funzionali del servizio.

La versione aggiornata sarà pubblicata su questa pagina con indicazione della data di ultimo aggiornamento.

14. CONTATTI

Per qualsiasi richiesta relativa alla presente Privacy Policy o al trattamento dei dati personali:

OFC S.R.L.
Viale San Nilo 39C, 00046 Grottaferrata (RM) – Italia
P.IVA: 16390181002
PEC: ofc@pecformail.it
Telefono: 0694502976
Email: privacy@onoranzefunebricloud.com`;

const isSectionTitle = (line) => /^\d+\.\s/.test(line);
const isSubsectionTitle = (line) => /^\d+\.\d+\s/.test(line);

const renderPrivacyContent = () => {
  const lines = privacyText.split("\n");
  const nodes = [];
  let listItems = [];

  const flushList = () => {
    if (!listItems.length) {
      return;
    }

    nodes.push(
      <ul
        key={`list-${nodes.length}`}
        className="list-disc space-y-2 pl-5 text-sm leading-7 text-slate-700"
      >
        {listItems.map((item, index) => (
          <li key={`${item}-${index}`}>{item}</li>
        ))}
      </ul>,
    );
    listItems = [];
  };

  lines.forEach((rawLine, index) => {
    const line = rawLine.trim();

    if (!line) {
      flushList();
      return;
    }

    if (line.startsWith("- ")) {
      listItems.push(line.slice(2));
      return;
    }

    flushList();

    if (index === 0) {
      nodes.push(
        <h1
          key="title"
          className="text-3xl font-extrabold leading-tight text-slate-950 sm:text-5xl"
        >
          {line}
        </h1>,
      );
      return;
    }

    if (line.startsWith("Ultimo aggiornamento:")) {
      nodes.push(
        <p
          key="updated"
          className="text-xs font-extrabold uppercase tracking-[0.14em] text-[#1b8395]"
        >
          {line}
        </p>,
      );
      return;
    }

    if (line === "INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI") {
      nodes.push(
        <p
          key="subtitle"
          className="text-base font-extrabold uppercase tracking-[0.08em] text-slate-700"
        >
          {line}
        </p>,
      );
      return;
    }

    if (isSubsectionTitle(line)) {
      nodes.push(
        <h3
          key={`subsection-${index}`}
          className="pt-5 text-lg font-extrabold leading-tight text-slate-950"
        >
          {line}
        </h3>,
      );
      return;
    }

    if (isSectionTitle(line)) {
      nodes.push(
        <h2
          key={`section-${index}`}
          className="pt-8 text-xl font-extrabold leading-tight text-slate-950 sm:text-2xl"
        >
          {line}
        </h2>,
      );
      return;
    }

    nodes.push(
      <p key={`p-${index}`} className="text-sm leading-7 text-slate-700">
        {line}
      </p>,
    );
  });

  flushList();
  return nodes;
};

function PrivacyPage() {
  useEffect(() => {
    setPageSeo(privacySeo);
  }, []);

  return (
    <div className="min-h-screen bg-[#e8eef2] font-Poppins text-slate-950">
      <header className="bg-[#17465c] text-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-3 py-4 sm:px-5">
          <a href="/" className="flex items-center">
            <img
              src={cardsWhiteLogoUrl}
              alt="Cards"
              className="h-9 w-auto"
            />
          </a>
          <a
            href="/"
            className="rounded-md bg-white/10 px-3 py-2 text-xs font-bold text-white ring-1 ring-white/20 transition hover:bg-white/15"
          >
            Homepage
          </a>
        </div>
      </header>

      <main className="px-4 py-8 sm:px-5 sm:py-12">
        <article className="mx-auto max-w-4xl rounded-lg bg-white px-5 py-8 shadow-xl shadow-slate-950/10 ring-1 ring-slate-200 sm:px-8 sm:py-10">
          <div className="space-y-5">{renderPrivacyContent()}</div>
        </article>
      </main>
    </div>
  );
}

export default PrivacyPage;
